var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{attrs:{"grid-id":"details-network-grid","no-records":'No associated records found',"fields":_vm.fields,"items":_vm.details.network}})}
var staticRenderFns = []

export { render, staticRenderFns }